<template>
  <div id="productWrapper">
    <div class="columns">
      <div class="column">
        <div class="notification" v-if="loading">Laden...</div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-one-fifth">
        <p><router-link :to="{ name: 'knowledges' }"><span class="icon"><i class="fas fa-chevron-left"></i></span> Terug</router-link></p>
      </div>

      <div class="column is-four-fifths-table is-half-desktop">
        <div class="card">

          <http-messages :success="success" :errors="errors"></http-messages>

          <header class="card-header">
            <p class="card-header-title">Kennisitem bewerken</p>
          </header>

          <div class="card-content">
            <form>
              <div v-if="isAdmin" class="field">
                <div class="label">
                  <label for="name" class="label">Leverancier</label>
                </div>
                <div class="control">
                  <div class="select">
                    <select name="supplier_id" v-model="item.supplier_id">
                      <option v-for="supplier in suppliers" :value="supplier.id">{{ supplier.name }}</option>
                    </select>
                  </div>
                </div>
                <p v-for="message in errors.supplier_id" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <div class="label">
                  <label for="title" class="label">Titel</label>
                </div>
                <div class="control">
                  <input class="input" type="text" name="title" v-model="item.title">
                </div>
                <p v-for="message in errors.title" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <div class="label">
                  <label for="description" class="label">Beschrijving <span v-if="item.description" class="is-pulled-right">({{ item.description.length }}/3000)</span></label>
                </div>
                <div class="control">
                  <vue-editor v-model="item.description" :editorToolbar="customToolbar"></vue-editor>
                </div>
                <p v-for="message in errors.description" class="help is-danger">{{ message }}</p>
              </div>

              <hr/>

              <p class="has-text-weight-bold">Bijlages</p>

              <div class="notification is-danger" :class="{ 'is-hidden': !tooLarge && !invalidExtension }">
                <p v-show="tooLarge">Het bestand is te groot, de maximale toegestane bestandsgrootte is 2MB.</p>
                <p v-show="invalidExtension">Dit bestandstype is niet toegestaan. Alleen .pdf, .jpg en .png zijn toegestane bestandstypen</p>
              </div>

              <div v-if="item.attachments" class="is-clipped">
                <article v-for="(attachment, index) in item.attachments" class="media">
                  <div class="media-left">
                    <figure class="image is-128x128" :style=" isImage(attachment.file) ? 'background-image: url(' + attachment.file + ')' : 'background-image: url(' + placeholder + ')'"></figure>
                  </div>

                  <div class="media-content">
                    <div class="field is-horizontal">
                      <div class="field-label is-small">
                        <label class="label">Naam</label>
                      </div>

                      <div class="field-body">
                        <div class="field">
                          <p class="control">
                            <input class="input" type="text" v-model="attachment.name">
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="field is-horizontal">
                      <div class="field-label is-small">
                        <label class="label">Bijschrift</label>
                      </div>

                      <div class="field-body">
                        <div class="field">
                          <p class="control">
                            <input class="input" type="text" v-model="attachment.caption">
                          </p>
                        </div>
                      </div>
                    </div>

                    <nav class="level is-mobile is-pulled-right">
                      <div class="level-left">
                        <a class="level-item" aria-label="delete" @click="removeAttachment(index)">
                          Bijlage verwijderen
                        </a>
                      </div>
                    </nav>
                  </div>
                </article>
              </div>

              <hr/>

              <v-uploader @done="uploadDone" :preview="false" button-text="Nieuwe bijlage uploaden" file-size-limit="2MB"></v-uploader>
              <ul class="upload-rules">
                <li>Afbeeldingen mogen maximaal 2MB groot zijn</li>
                <li>Toegestane bestanden zijn .pdf, .jpg en .png</li>
              </ul>

            </form>

          </div>

          <footer class="card-footer">
            <a
              class="button is-text card-footer-item"
              @click="save"
              :class="{ 'is-loading': loading }">
              Opslaan
            </a>
          </footer>

        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-four-fifths-tablet is-half-desktop is-offset-one-fifth">
        <button v-show="item.id" type="button" class="button is-danger is-fullwidth" @click="delItem">Item verwijderen</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { bus } from '../../main'
  import { VueEditor } from 'vue2-editor'
  import HttpMessages from '@/components/http/HttpMessages'

  export default {
    components: {
      HttpMessages,
      VueEditor
    },
    data() {
      return {
        loading: false,
        errors: {},
        success: false,
        invalidExtension: false,
        tooLarge: false,
        item: {
          attachments: []
        },
        suppliers: [],
        customToolbar: [
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered'}, {list: 'bullet'}]
        ],
        placeholder: 'static/assets/images/pdf.png'
      }
    },
    computed: {
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      params () {
        return this.$store.getters.params
      }
    },
    created () {
      let self = this

      if (this.$route.params.id) this.fetchData(this.$route.params.id)

      if (this.isAdmin)
        this.fetchSuppliers()

      bus.$on('uploadError', (payload) => {
        if (payload.includes('too large')) {
          self.tooLarge = true
        }

        if (payload.includes('invalid extension')) {
          self.invalidExtension = true
        }
      })
    },
    methods: {
      fetchData (id) {
        this.loading = true
        axios
          .get('/knowledge/' + id, this.params)
          .then(response => {
            this.loading = false
            this.item = response.data
            if (!this.item.attachments)
              this.item.attachments = []
          }).catch(error => {
            this.loading = false
            this.errors = error.response.data.message || error.message
          });
      },
      fetchSuppliers () {
        this.loading = true
        axios
          .get('/suppliers', this.params)
          .then(response => {
            this.loading = false
            this.suppliers = response.data
          }).catch(error => {
            this.loading = false
            this.errors = error.response.data.message || error.message
          });
      },
      save () {
        this.loading = true
        this.errors = {}
        this.success = false

        if (this.item.id) {
          axios
            .put('/knowledge/' + this.item.id, this.item)
            .then(response => {
              this.loading = false
              this.success = true
            })
            .catch((error) => {
              this.loading = false
              this.errors = error.response.data.errors
            })
        } else {
          axios
           .post('/knowledge', this.item)
           .then(response => {
            this.loading = false
            this.success = true
            this.$router.push({name: 'knowledge-edit', params: { id: response.data.id }})
           })
           .catch((error) => {
            this.loading = false
            this.errors = error.response.data.errors
           })
        }
      },
      uploadDone (files) {
        this.clearErrors()
        if (files[0].success) this.item.attachments.push({
          file: files[0].url
        })
      },
      removeAttachment (index) {
        this.item.attachments.splice(index, 1)
      },
      isImage (filename) {
        let images = [
          'jpeg',
          'jpg',
          'png'
        ]

        return images.includes(filename.split('.').pop())
      },
      delItem () {
        axios
          .delete('/knowledge/' + this.item.id)
          .then(response => {
            this.$router.push({name: 'knowledge'})
          })
          .catch((error) => {
            console.log(error)
          })
      },
      clearErrors () {
        this.tooLarge = this.invalidExtension = false
      }
    }
  }
</script>

<style scoped>
  .button.is-text {
    text-decoration: none;
  }

  .media-content .level {
    margin-top: 2rem;
  }

  figure {
    margin: 15px 15px 15px 0;
    background-color: #333;
    background-size: cover;
  }

  .is-overlay {
    left: 5px;
    top: 5px;
  }

  .upload-rules {
    font-size: 10px;
    font-weight: light;
  }
</style>



// WEBPACK FOOTER //
// src/components/knowledge/KnowledgeItemEdit.vue